export default __webpack_public_path__ + "static/media/Project-2.7052130e.jpg";